/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.megaMenus = Shopify.theme.megaMenus || {}
  Shopify.theme.jsMegaMenu = {
    init: function ($section) {
      // Add settings from schema to current object
      Shopify.theme.jsMegaMenu = $.extend(this, Shopify.theme.getSectionData($section));
      // Selectors
      const link = this.parent_link;
      const id = this.section_id
      if (!link || !id) return;
      Shopify.theme.megaMenus[link] = {
        $section,
        link,
        id,
        $menu: $section.find(`[data-mega-menu-id="${this.section_id}"]`).attr('data-mega-menu-link', link),
        $link: $('[data-link-handle="' + link + '"]').attr('data-mega-menu-id', id)
      }
      if (!isScreenSizeLarge())
        return;
      Shopify.theme.megaMenus[link].$menu.detach().appendTo('#header')
      Shopify.theme.megaMenus[link].$link.find('.header__link').addClass('is-arrowless')
      Shopify.theme.megaMenus[link].$link.find('.navbar-dropdown').addClass('is-invisible is-hidden');

      Shopify.theme.megaMenus[link].$link.on('mouseover', this.handleOpen.bind(this))
      Shopify.theme.megaMenus[link].$menu.find('[data-link-title]').on('mouseover', this.handleInnerLinkClick.bind(this, link))
      $('.mega-menu__section, .header').on('mouseleave', this.closeAll.bind(this))
    },
    handleInnerLinkClick: function (link, e) {
      let clickedLink;
      if($(e.target).parent().parent().data('link-title') == undefined){
        clickedLink = $(e.target).data('link-title');
      }else{
        clickedLink = $(e.target).parent().parent().data('link-title');
      }
      Shopify.theme.megaMenus[link].$menu.find(`[data-link]`).hide();
      Shopify.theme.megaMenus[link].$menu.find(`[data-link="${clickedLink}"]`).show()
    },
    handleOpen: function (e) {
      let link = $(e.target).attr('data-link-handle') || $(e.target).parents('[data-link-handle]').attr('data-link-handle')
      if (link)
        this.displayMenu(false, link)
    },
    showThemeEditorState: function (id, $section) {
      let menu = this.findById(id)
      Shopify.theme.jsHeader.disableOverlayStyle(true)
      menu.$menu.addClass('mega-menu--force-show');
      menu.$link.addClass('is-active');
    },
    findById: function (id) {
      let links = Object.keys(Shopify.theme.megaMenus)
      let selectedLink = links.filter(link => Shopify.theme.megaMenus[link].id == id)[0]
      return Shopify.theme.megaMenus[selectedLink]
    },
    hideThemeEditorState: function (id, $section) {
      let menu = this.findById(id)
      Shopify.theme.jsHeader.enableOverlayStyle(true)
      menu.$menu.removeClass('mega-menu--force-show');
      menu.$link.removeClass('is-active');
    },
    displayMenu: function (id, link) {
      this.closeAll()
      Shopify.theme.jsHeader.disableOverlayStyle(true)
      console.log(link,Shopify.theme.megaMenus[link])
      if (link && Shopify.theme.megaMenus[link]) {
        Shopify.theme.megaMenus[link].$link.find('.header__link').addClass('is-active')
        return Shopify.theme.megaMenus[link].$menu.addClass('is-active')
      }
      let menu = this.findById(id)
      menu.$menu.addClass('mega-menu--show');
    },
    hideMenu: function (id, link) {
      Shopify.theme.jsHeader.enableOverlayStyle(true)
      $('.mega-menu__' + id + ' .mega-menu').removeClass('mega-menu--show');
    },
    closeAll: function () {
      if (Shopify.theme.jsHeader.enable_overlay == true) {
        Shopify.theme.jsHeader.enableOverlayStyle(true)
      }
      $('[data-link-handle]').find('.header__link').removeClass('is-active')
      $('[data-mega-menu]').removeClass('is-active')
    },
    unload: function (menu) {
      menu.$menu.detach().appendTo(menu.$section)
      menu.$link.off('mouseover')
      $('.mega-menu__section, .navbar').off('mouseleave')
    }
  }

  /******/
})()
  ;


$(document).ready(function(){
  var value = $($('.mega-menu__linklist ul li a')[0]).data('link-title');
  $('.mega-menu__collections .list-collection__thumbnail[data-link="'+value+'"]').show();
});                